// extracted by mini-css-extract-plugin
export default {"titleImage":"TitleImage_titleImage__WItZB","titleOverlay":"TitleImage_titleOverlay__+1fp6","quoteButton":"TitleImage_quoteButton__V69zp","quotelink":"TitleImage_quotelink__oBu5H"};